"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SALES_CHANNEL = void 0;
var SALES_CHANNEL;
(function (SALES_CHANNEL) {
    SALES_CHANNEL["INSTORE"] = "In Store";
    SALES_CHANNEL["DOORDASH"] = "DoorDash";
    SALES_CHANNEL["UBSEREATS"] = "Uber Eats";
    SALES_CHANNEL["DELIVEROO"] = "Deliveroo";
    SALES_CHANNEL["MENULOG"] = "Menulog";
    SALES_CHANNEL["ONLINE"] = "ONLINE";
    SALES_CHANNEL["DELIVERECT"] = "Deliverect";
    SALES_CHANNEL["KIOSK"] = "Kiosk";
})(SALES_CHANNEL = exports.SALES_CHANNEL || (exports.SALES_CHANNEL = {}));
//# sourceMappingURL=salesChannels.js.map